export function formatNumber(number, prefix='', suffix='', decimals) {
    if (!number) {
        number = 0;
    }
    let numberFormat = number.toLocaleString('es-CL', {maximumFractionDigits: decimals})
    return `${prefix}${numberFormat}${suffix}`;
}